module.exports = __webpack_public_path__ + "static/media/9.237454e9.png";